import { NgModule } from '@angular/core';
import { ContactListEditorComponent } from './c-list-editor.component';
import { FuseSharedModule } from '@fuse/shared.module';
import {
    MatButtonModule,
    MatChipsModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatRippleModule,
    MatSelectModule,
    MatSortModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatMenuModule,
    MatToolbarModule,
    MatDialogModule,
    MatListModule,
    MatCheckboxModule,
    

    
} from '@angular/material';
import { FuseConfirmDialogModule } from '@fuse/components';
import { AutoCompleteModule } from 'app/_shared/auto-complete/auto-complete.module';

@NgModule({
    declarations: [ContactListEditorComponent],
    imports: [
        FuseSharedModule,
        MatButtonModule,
        MatChipsModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatPaginatorModule,
        MatRippleModule,
        MatSelectModule,
        MatSortModule,
        MatSnackBarModule,
        MatTableModule,
        MatTabsModule,
        MatMenuModule,
        MatListModule,
        MatToolbarModule,
        FuseConfirmDialogModule,
        MatDialogModule,
        AutoCompleteModule,
        MatCheckboxModule
    ],
    entryComponents: [ContactListEditorComponent]
})
export class ContactListEditorModule {}
